import Modal from "bootstrap/js/src/modal";
import {createElement} from "../util/utils";

const { __ } = wp.i18n;

export default class CountrySelector {
  constructor(args = {})
  {
    if (CountrySelector.exists) {
      return CountrySelector.instance;
    }

    CountrySelector.instance = this;
    CountrySelector.exists = true;

    this.args = args;
    this.modal = null;
    this.wrapper = null;
    this.selected = null;
    this.items = [];
    this.onCountryChange = null;
    this.searchInput = null;
  }

  /**
   * @param data object params: countries {code: name}, selected: code, onCountryChange: function
   */

  open(data)
  {
    // If no countries return
    if(!data.countries || 'object' !== typeof data.countries) {
      return;
    }

    this.onCountryChange = data.onCountryChange;

    if(!this.modal) {
      this.modal = this.createModal(data.countries);
    } else {
      //Do nothing if modal is open
      if(this.modal._isShown) {
        return;
      }
      //Clear countries
      this.clearCountries();
    }

    this.selected = data.selected || null;

    for (const [code, name] of Object.entries(data.countries)) {
      this.items.push(this.createCountryItem(code, name));
    }

    this.modal.show();
  }

  clearCountries()
  {
    this.items.forEach(item => item.remove());
    this.items = [];
    this.selected = null;
    if(this.wrapper) {
      this.wrapper.innerHTML = '';
    }
  }

  close()
  {
    if(this.modal) {
      this.modal.hide();
    }
  }

  createModal()
  {
    const modal = createElement({
      classes: ['country-selector', 'modal', 'fade'],
      attributes: {
        id: 'countrySelector',
        tabindex: '-1',
        ariaHidden: "true",
      },
      parent: document.body,
    });

    const dialog = createElement({
      classes: ['modal-dialog', 'modal-dialog-centered'],
      parent: modal,
    });

    const content = createElement({
      classes: ['modal-content'],
      parent: dialog,
    });

    const header = createElement({
      classes: ['modal-header'],
      parent: content,
    });

    createElement({
      tagname: 'label',
      classes: ['sr-only'],
      attributes: {
        for: 'country-filter',
      },
      textContent: __('Choose country', 'canopia'),
      parent: header,
    });

    this.searchInput = createElement({
      tagname: 'input',
      classes: ['country-selector__input'],
      attributes: {
        type: 'text',
        placeholder: __('Choose country', 'canopia'),
        id: 'country-filter',
      },
      parent: header,
    });

    this.searchInput.addEventListener('keyup', this.filter);

    createElement({
      tagname: 'button',
      classes: ['btn-close'],
      attributes: {
        type: 'button',
        ariaLabel: __('Close', 'canopia'),
      },
      dataset: {
        bsDismiss: 'modal',
      },
      parent: header,
    });

    const body = createElement({
      classes: ['modal-body'],
      parent: content,
    });

    this.wrapper = createElement({
      classes: ['row'],
      parent: body,
    });

    modal.addEventListener('shown.bs.modal', this.onModalShown);

    if(this.args.dropdown) {
      modal.addEventListener('shown.bs.modal', () => {
        this.args.dropdown._config.autoClose = false;
      });

      modal.addEventListener('hidden.bs.modal', () => {
        this.args.dropdown._config.autoClose = true;
      });
    }

    return new Modal(modal);
  }

  createCountryItem(code, name)
  {
    if(!this.wrapper) {
      return;
    }

    const item = createElement({
      classes: ['country-selector__item', 'col-6', 'col-md-4', 'mb-15'],
      parent: this.wrapper,
    })

    const button = createElement({
      tagname: 'button',
      classes: ['btn-default', 'btn-country-select'],
      attributes: {
        type: 'button',
      },
      dataset: {
        code,
      },
      textContent: name,
      parent: item,
    });

    if(this.selected === code) {
      button.classList.add('active');
    }

    button.addEventListener('click', this.onCountrySelect);

    return item;
  }

  filter = event => {
    if(this.items.length < 2) {
      return;
    }

    let value = event.target.value.toUpperCase();

    this.items.forEach(item => {
      const button = item.querySelector('button');
      const name = button.textContent.toUpperCase();

      if(name.indexOf(value) > -1) {
        item.removeAttribute('style');
      } else {
        item.style.display = 'none';
      }
    });
  }

  onCountrySelect = event => {
    event.preventDefault();
    const button = event.target;
    const code = button.dataset.code;
    const name = button.textContent;

    this.close();

    if('function' === typeof this.onCountryChange && this.selected !== code) {
      this.onCountryChange({code, name});
    }
  };

  onModalShown = event => {
    if(this.searchInput) {
      this.searchInput.focus();
    }
  };
}
